/**
 * Cosa dice il pannello mentre il modello non ha ancora scritto nulla. Con il
 * ragionamento acceso l'attesa prima del primo token cresce, e tre puntini
 * muti sembrano un blocco: una frase che cambia dice che qualcosa accade.
 */

export const FRASI_ATTESA: readonly string[] = [
  "Sto leggendo le schede…",
  "Sto ragionando…",
  "Sto analizzando l'obbligo…",
  "Sto cercando il riferimento normativo…",
  "Sto mettendo in ordine la risposta…",
];

/** Una frase diversa da quella corrente; `caso` e' un numero in [0, 1). */
export function prossimaFrase(corrente: string | null, caso: () => number): string {
  const candidate = FRASI_ATTESA.filter((f) => f !== corrente);
  return candidate[Math.min(candidate.length - 1, Math.floor(caso() * candidate.length))];
}
